// Returns whether the logged in user has access to a given ScreenURL,
// based on the screens array returned by getScreenMasterList.
// A URL not present in the list (e.g. it isn't a rights-controlled screen)
// is allowed by default.
export const hasScreenAccess = (screenRights, screenUrl) => {
    if (!screenUrl) return true;

    const screen = screenRights?.find((item) => item.ScreenURL === screenUrl);
    if (!screen) return true;

    return !!screen.HasAccess;
};
